import { toast } from '@/components/toast';
import { getPresenters } from '@/services/api';
import { useAuth } from '@/services/auth';
import { logger } from '@/services/logger';
import { GET_PRESENTERS_KEY_TYPE } from '@/state/presenters';
import { ImageType } from '@d-id/types';
import { useQuery } from 'react-query';

export function useGetBackgroundsList() {
    const { isAnonymous } = useAuth();
    const type = ImageType.Backgrounds;

    return useQuery(GET_PRESENTERS_KEY_TYPE(type), getPresenters({ type, isAnonymous }), {
        onSuccess(data) {
            data.forEach(image => (new Image().src = image.thumbnail));
            data.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
        },
        onError(err) {
            logger.error('Could not fetch presenters', { err });
            toast.error({ title: 'Could not fetch presenters', toastId: `${GET_PRESENTERS_KEY_TYPE(type)}-error` });
        },
    });
}
